<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form  @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="关键字 :" prop="projectName" placeholder="请输入">
              <el-input v-model="form.projectName"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="类型 :" prop="status">
              <el-select v-model="form.status" placeholder="请选择">
                <el-option v-for="item in statusList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加修复记录
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <!-- <el-table-column prop="collectionNo" label="藏品编号" min-width="8%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="collectionName" label="藏品名称" min-width="11%"></el-table-column>
          <el-table-column prop="collectionType" label="藏品类别" min-width="8%">
            <template slot-scope="scope">{{ scope.row.collectionType | filterType(that)}}</template>
          </el-table-column> -->
          <el-table-column prop="projectName" label="项目名称" min-width="12%">
            <template slot-scope="scope"><a class="m-btn mr-10" @click="handleProject(scope.row)">{{ scope.row.projectName}}</a></template>
          </el-table-column>
          <el-table-column prop="personInCharge" label="修复负责人" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="修复状态" min-width="6%">
            <template slot-scope="scope">{{ scope.row.status | filterStatus(that)}}</template>
          </el-table-column>
          <el-table-column prop="beginTime" label="开始修复时间" min-width="12%"></el-table-column>
          <el-table-column prop="endTime" label="修复完成时间" min-width="12%"></el-table-column>
          <el-table-column prop="createTime" label="添加时间" min-width="12%">
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.createTime, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="mark" label="备注" min-width="20%"></el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="12%">
            <template slot-scope="scope">
              <!-- <a class="m-btn mr-10" @click="fillFix(scope.row.id)">修复方案填写</a> -->
              <a class="m-btn mr-10" @click="handlerView(scope.row.id)">查看</a>
              <a class="m-btn mr-10" @click="handlerEdit(scope.row)">编辑</a>
              <a class="m-btn m-danger" @click="handlerDelete(scope.row.id)">删除</a>

              <!-- <a class="m-btn mr-10" @click="handleAdd('edit', scope.row.id)">预览</a> -->
              <!-- <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)">打印</a> -->
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
    <el-dialog :title="operation == 'add' ? '新增修复记录' : operation == 'edit' ? '编辑修复记录' : '查看修复记录'" :visible.sync="dialogVisible" width="30%" @close="handleClose">
      <el-form class="g-form-grid" ref="addForm" :model="addForm" label-width="120px" :rules="rules">
        <!-- <el-form-item label="藏品名称 :" prop="collectionName">
          <el-input v-model="addForm.collectionName" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="藏品编号 :" prop="collectionNo">
          <el-input v-model="addForm.collectionNo" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="藏品类别 :" prop="collectionType">
          <el-select v-model="addForm.collectionType " placeholder="请选择">
            <el-option v-for="item in typeList1" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="项目名称 :" prop="projectName">
          <el-input v-model="addForm.projectName" :disabled="operation=='view'" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="修复开始时间 :" prop="beginTime">
          <el-date-picker v-model="addForm.beginTime" :disabled="operation=='view'" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <el-form-item label="修复完成时间 :" prop="endTime">
          <el-date-picker v-model="addForm.endTime" :disabled="operation=='view'" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <el-form-item label="修复状态 :" prop="status">
          <el-select v-model="addForm.status" :disabled="operation=='view'" placeholder="请选择">
            <el-option v-for="item in statusList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="修复责任人 :" prop="personInCharge">
          <el-input v-model="addForm.personInCharge" :disabled="operation=='view'" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="备注 :" prop="mark">
          <el-input type="textarea" :disabled="operation=='view'" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容" v-model="addForm.mark"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer" v-if="operation !='view'">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="loadingSave" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      that: this,
      form: {
        projectName: '',
        status: '', //	活动类型
      },
      operation: '',
      addForm: {
        projectName: '',
        status: '',
        mark: '',
        personInCharge: '',
        beginTime: '',
        endTime: ''
      },
      loadingSave: false,
      rules: {
        projectName: [
          { required: true, message: '项目名称不能为空', trigger: 'blur' },
        ],

        beginTime: [
          { required: true, message: '修复开始时间不能为空', trigger: 'blur' },
        ],

        endTime: [
          { required: true, message: '修复完成时间不能为空', trigger: 'blur' },
        ],

        personInCharge: [
          { required: true, message: '修复责任人不能为空', trigger: 'blur' },
        ],

        status: [
          { required: true, message: '修复状态不能为空', trigger: 'blur' },
        ],

      },
      dialogVisible: false,
      typeList: [],
      typeList1: [],

      statusList: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
    }
  },
  filters: {
    filterType(type, that) {
      let obj = that.typeList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },
    filterStatus(type, that) {
      let obj = that.statusList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    }
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      // this.$http
      //   .get('/repair/bsRepairManagement/pageList', {
      //     ...this.listQuery,
      //     ...this.form
      //   })
      this.$api.repair.getRepairProjectList({
        ...this.listQuery,
        ...this.form
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          let results = res.result
          this.tableData = results.records
          this.total = results.total
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.listLoading = false
      })
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['new_repair_status', 'new_repair_type']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.typeList = firstArr.concat(state['new_repair_type'])
            this.typeList1 = state['new_repair_type']

            this.statusList = state['new_repair_status']
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 查看
    handlerView(id) {
      this.operation = "view"
      this.$api.repair.getRepairProjectDetail({ id: id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
          }
        }
      })
    },

    // 编辑
    handlerEdit(obj) {
      this.operation = 'edit'
      this.addForm = JSON.parse(JSON.stringify(obj))
      this.dialogVisible = true
    },

    // 删除
    handlerDelete(id) {
      this.$common.confirm(
        {
          title: '是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.repair.delteRepairProject({ id: id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.initList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    handleClose() {
      this.$refs['addForm'].resetFields()
      this.$refs["addForm"].clearValidate()
      this.dialogVisible = false
    },

    handleProject(obj) {
      this.$router.push({
        path: '/repair/repair-cultural',
        query: { projectId: obj.id }
      })
    },

    // 提交
    handleSubmit() {
      if (this.addForm.mark && this.addForm.mark.length > 0) {
        this.addForm.mark = this.addForm.mark.slice(0, 100)
      }
      this.$refs['addForm'].validate(vaild => {
        if (vaild) {
          let url = "addRepairProject"
          this.loadingSave = true
          if (this.operation == 'edit') {
            url = 'updateRepairProject'
          }
          this.$api.repair[url](this.addForm).then(res => {
            this.loadingSave = false
            if (res.success) {
              if (this.operation == 'edit') {
                this.$message.success('修复记录修改成功')
              } else {
                this.$message.success('新增修复记录成功')
              }
              this.handleClose()
              this.getTableList()
            } else {
              this.$message.error(res.message)

            }
          }).catch(err => {
            this.loadingSave = false
          })
        }
      })
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 新增
    handleAdd() {
      this.operation = 'add'
      this.dialogVisible = true
    },

    fillFix(id) {
      this.$router.push({
        path: '/repair/repair-fill',
        query: { repairId: id }
      })
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },

  },
  created() {
    this.initList()
    this.getDropdownValue()
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-date-editor {
  width: 100%;
}
</style>